import React from "react";
import { Input, Text } from "components";

interface TextEditorProps {
  value: string;
  onChange: (content: string) => void;
  title?: string;
  subtitle?: string;
  height?: string;
}

export const InputItem: React.FC<TextEditorProps> = ({
  value,
  onChange,
  title,
  subtitle,
}) => {
  return (
    <div>
      {title && <Text.Body2XS color="darkGrey">{title}</Text.Body2XS>}
      <br />
      {subtitle && <Text.Body2XS marginTop={2}>{subtitle}</Text.Body2XS>}
      <div style={{ width: "100%", marginTop: "10px" }}>
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{ width: "100%" }}
          placeholder="https://calendar.app.google/fKShuMCge7dh9"
        />
      </div>
    </div>
  );
};
